'use strict';

(function () {

	function showLogin() {
		var triggers = document.querySelectorAll('.js-show-login');
		var loginForm = document.querySelector('.login-form');

		triggers.forEach(function (trigger) {
			trigger.addEventListener('click', function (e) {
				e.preventDefault();
				if (loginForm) {
					if (loginForm.style.display === 'block') {
						loginForm.style.display = 'none';
					} else {
						loginForm.style.display = 'block';
					}
				}
			});
		});
	}

	document.addEventListener('DOMContentLoaded', showLogin);

	function animate() {
		var elements = document.querySelectorAll('.animate');

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('visible');
				}
			});
		});

		elements.forEach(function (element) {
			observer.observe(element);
		});
	}

	document.addEventListener('DOMContentLoaded', animate);
})();